import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Switch, Route, Link, Redirect } from "react-router-dom";
import { VTab, VTabs, ContentGroup } from "../Styles";
import { Jobs, VTabAlert, Settings } from ".";
import { NewAlert, EditAlert } from "../Alerts";
import Resumes from "./Resumes";
import ProfileContainer from "./ProfileContainer";
import { getAppliedJobs as getAppliedJobsAction } from "../../redux/middleware/job";
import { deleteAlert as deleteAlertAction } from "../../redux/middleware/user";
import {
  uploadResume as uploadResumeAction,
  getResumes as getResumesAction,
  deleteResume as deleteResumeAction,
} from "../../redux/middleware/resume";
import {
  getResumes as getResumesState,
  getResumeError,
  getResumePending,
} from "../../redux/reducers/resume";

class Dashboard extends Component {
  componentWillMount() {
    const { user, appliedJobs, getResumes } = this.props;
    if (user) {
      appliedJobs(user);
      getResumes(user);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { user, appliedJobs, getResumes, alertPending } = this.props;
    if (!user && nextProps.user) {
      appliedJobs(nextProps.user);
      getResumes(user);
    }

    nextProps.applied &&
      this.setState({
        jobs: nextProps.applied.jobs,
        alerts: nextProps.applied.alerts,
        resumes: nextProps.resumes,
        profiles: nextProps.applied.profiles,
        resumePending: nextProps.resumePending,
        loaded: true,
      });
    if (alertPending && !nextProps.alertPending) {
      this.setState((prevState) => ({
        ...prevState,
        alerts: prevState.alerts.filter((a) => a.id !== nextProps.userAlert.id),
      }));
    }
  }

  handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({ [name]: value });
  };

  getAlert = (id) => {
    return (
      this.state.alerts &&
      this.state.alerts.filter((alert) => alert.id === id)[0]
    );
  };

  deleteAlert = (alert) => {
    this.props.deleteAlert(alert);
  };

  removeResume = (resume) => {
    const { deleteResume, user } = this.props;
    deleteResume(user, resume);
  };

  addResume = (resume) => {
    if (resume) {
      const { uploadResume, user } = this.props;
      const { profiles } = this.state;
      const data = new FormData();
      data.append("resume", resume[0]);
      uploadResume(user.id, profiles[0].id, data, resume[0].name);
    }
  };

  isLocation = (pathname) => {
    return this.props.location.pathname === pathname;
  };

  render() {
    const { loaded } = this.state || {};
    return !loaded ? (
      <div>Loading Dashboard...</div>
    ) : (
      <div>
        <VTabs className="hidden-xs">
          <VTab className={this.isLocation(`/dashboard/profiles`) && "active"}>
            <Link to={`/dashboard/profiles`} data-toggle="tab">
              Profiles
            </Link>
          </VTab>
          <VTab className={this.isLocation(`/dashboard/jobs`) && "active"}>
            <Link to={`/dashboard/jobs`} data-toggle="tab">
              Jobs
            </Link>
          </VTab>
          <VTab className={this.isLocation(`/dashboard/resumes`) && "active"}>
            <Link to={`/dashboard/resumes`} data-toggle="tab">
              Resumes
            </Link>
          </VTab>
          {false && (
            <VTab className={this.isLocation(`/dashboard/alerts`) && "active"}>
              <Link to={`/dashboard/alerts`} data-toggle="tab">
                Alerts
              </Link>
            </VTab>
          )}
          <VTab className={this.isLocation(`/dashboard/settings`) && "active"}>
            <Link to={`/dashboard/settings`} data-toggle="tab">
              Settings
            </Link>
          </VTab>
        </VTabs>
        <ContentGroup>
          <Switch>
            <Route
              path="/dashboard/profiles"
              render={() => (
                <ProfileContainer {...this.props} {...this.state} />
              )}
            />
            <Route
              exact
              path="/dashboard"
              render={() => <Redirect to="/dashboard/profiles" />}
            />
            <Route
              exact
              path="/dashboard/jobs"
              render={() => (
                <Jobs
                  {...this.props}
                  jobs={this.state.jobs}
                  remove={this.removeJob}
                />
              )}
            />
            <Route
              exact
              path="/dashboard/resumes"
              render={() => (
                <Resumes
                  {...this.props}
                  resumes={this.state.resumes}
                  resumePending={this.state.resumePending}
                  remove={this.removeResume}
                  add={this.addResume}
                />
              )}
            />
            <Route
              exact
              path="/dashboard/alerts/new"
              render={() => <NewAlert {...this.props} />}
            />
            <Route
              exact
              path="/dashboard/alerts/:alertId/edit"
              render={(props) => (
                <EditAlert
                  {...this.props}
                  alert={this.getAlert(
                    parseInt(props.match.params.alertId, 10)
                  )}
                />
              )}
            />
            <Route
              exact
              path="/dashboard/alerts"
              render={() => (
                <VTabAlert
                  {...this.props}
                  alerts={this.state.alerts}
                  delete={this.deleteAlert}
                />
              )}
            />
            <Route
              exact
              path="/dashboard/settings"
              render={() => <Settings {...this.props} />}
            />
          </Switch>
        </ContentGroup>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  applied: state.job.applied,
  user: state.userByToken.user,
  resumes: getResumesState(state),
  resumePending: getResumePending(state),
  resumeError: getResumeError(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      appliedJobs: getAppliedJobsAction,
      uploadResume: uploadResumeAction,
      getResumes: getResumesAction,
      deleteResume: deleteResumeAction,
      deleteAlert: deleteAlertAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
